import Client from "./client";
import addCommonCalls from "./calls/common";
import addMatchingStrategyCalls from "./calls/matching-strategy";
import addMonitoringCalls from "./calls/monitoring";

addCommonCalls(Client);
addMatchingStrategyCalls(Client);
addMonitoringCalls(Client);

const client = new Client();
export default client;
